import script from "./TeamsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamsPage.vue?vue&type=script&setup=true&lang=js"

import "./TeamsPage.vue?vue&type=style&index=0&id=4086c9bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4086c9bd"]])

export default __exports__